import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { Col, Container, Card, CardBody, Button } from 'reactstrap';
import { withStyles } from "@material-ui/core/styles";
import FormHelperText from '@material-ui/core/FormHelperText';
import Modal from '@material-ui/core/Modal';
import ModalMessage from '../../../shared/components/Modal';
import MapAddressSearch from '../../../shared/components/MapAddressSearch';
import history from '../../../history';
import Input from '@material-ui/core/Input';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const styles = theme => ({
    date: {
        margin: 10,
        width: 215
    },
});

const MedicalCheckbox = withStyles({
    root: {
        '&$checked': {
            color: '#4ce1b6',
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    getContentAnchorEl: null,
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 650,
        },
    },
};

class FormProfessional extends Component {
    constructor(props) {
        super(props);
        this.state = {
            typeOfDocument: '',
            documentNumber: '',
            id_professional: '',
            names: '',
            firstLastName: '',
            secondLastName: '',
            regMed: '',
            rethus: '',
            licOC: '',
            address: '',
            cellphone: '',
            telephone1: '',
            telephone2: '',
            email: '',
            tipoProf: '',
            tipoCont: '',
            esp: '',
            id_ciudad: '',
            id_especialidad: '',
            username: '',
            password: '',
            id_perfil: '',
            country: '',
            department: '',
            city: '',
            regime: '',
            regimes: [],
            exist: false,
            update: false,
            errors: {},
            error: false,
            openAlert: false,
            modalAlert: { message: '', color: '', title: '' },
            openMap: false,
            departments: [],
            cities: [],
            specialtiesSpec: [],
            specialtiesSpecSelected: []
        }
    }

    handlerDocumentNumber = (number) => {
        this.setState({ documentNumber: number }, () => {
            //this.loadDataPatient();
        });
    }

    handlerTypeOfDocument = (type) => {
        this.setState({ typeOfDocument: type });
    }

    handlerNames = (names) => {
        this.setState({ names: names });
    }

    handlerFirstLastName = (name) => {
        this.setState({ firstLastName: name });
    }

    handlerSecondLastName = (name) => {
        this.setState({ secondLastName: name });
    }

    handlerBirthDate = (birthday) => {
        this.setState({ birthday: birthday });
    };

    handlerCountry = (country) => {
        this.setState({ country: country });
    }

    handlerDepartment = (department) => {
        console.log(department);

        this.setState({ department: department }, () => {
            this.loadCities(department).then((cities) => {
                this.setState({ cities: cities });
            });
        });

    }

    handleCity = (e) => {
        this.setState({ city: e });
    }

    handlerCity = (city) => {
        this.setState({ city: city });
    }

    handlerAddress = (address) => {
        this.setState({ address: address });
    }

    handlerTelephone1 = (telephone) => {
        this.setState({ telephone1: telephone });
    };

    handlerTelephone2 = (telephone) => {
        this.setState({ telephone2: telephone })
    };

    handlerCellphone = (cellphone) => {
        this.setState({ cellphone: cellphone })
    };

    handlerEmail = (email) => {
        this.setState({ email: email });
    };

    handlerTipoCont = (tipoCont) => {
        this.setState({ tipoCont: tipoCont })
    }

    handlerTiprof = (tipoProf) => {
        this.setState({ tipoProf: tipoProf })
    }

    handlerRegMed = (regMed) => {
        this.setState({ regMed: regMed })
    }

    handlerRethus = (rethus) => {
        this.setState({ rethus: rethus })
    }

    handlerLicOC = (licOC) => {
        this.setState({ licOC: licOC })
    }

    handlerSpecialties = (specialtiesSpecSelected) => {
        this.setState({ specialtiesSpecSelected: specialtiesSpecSelected })
    }

    componentDidMount = () => { 
        let id_depto;
        if(this.props.location.state !== null && this.props.location.state !== undefined){
            id_depto = this.props.location.state.professional?.contenido[0]?.direccion?.direccion[0]?.id_departamento;     
        }
        this.loadDepartment().then((departments) => {
            this.setState({ departments: departments }, () =>{
                this.loadCities(id_depto ? id_depto : '76').then((cities) => {
                    this.setState({ cities: cities });
                });
            });
        });
        this.loadProfessional(this.props);
        this.fetchDataSpecialist().then(response => {
            this.fetchDataRegisterSpecialistProfesionals();
        });
    }

    loadProfessional = (props) => {
        console.log(props.location.state.professional.contenido[0]);
        this.setProfessionalData(props.location.state.professional.contenido[0]);
    }

    setProfessionalData = (data) => {
        
            this.setState({
                typeOfDocument: data.tip_documento,
                documentNumber: data.num_documento,
                names: data.nombres,
                firstLastName: data.apellido1,
                secondLastName: data.apellido2,
                regMed: data.reg_medico,
                rethus: data.rethus,
                licOC: data.lic_salud_ocu,
                cellphone: data.celular1,
                telephone1: data.tel_fijo,
                telephone2: data.celular2,
                email: data.mail,
                tipoProf: data.tipo_profesional,
                tipoCont: data.tipo_contrato,
                id_especialidad: data.id_especialidad,
                id_professional: data.id_profesional,
                department: data.direccion === null ? '' :  data.direccion.direccion[0].id_departamento,
                city: data.direccion === null ? '' :   data.direccion.direccion[0].id_ciudad,
                id_ciudad: data.direccion === null ? '' :  data.direccion.direccion[0].id_ciudad,
                country: data.direccion === null ? '' :  parseInt(data.direccion.direccion[0].id_pais),
                address: data.direccion === null ? '' :  data.direccion.direccion[0].direccion,

            });        

        this.loadSpeciality(data.id_especialidad);
    }

    loadSpeciality = async (id) => {
        let data = { id: id };

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'especialidad/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                this.setState({ esp: data.contenido[0].especialidad });
            })
            .catch((error) => {
                console.error('Error:', error);

            });
    }

    loadDepartment = () => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'departamentos/listar', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    resolve(data);
                })
                .catch((error) => {
                    console.error('Error:', error);
                    resolve(error);
                });
        })
    }

    loadCities = (depcod) => {
        var data = { id_dpto: depcod };
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'ciudades/listar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(data)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log(data)
                    resolve(data);
                })
                .catch((error) => {
                    console.error('Error:', error);
                    resolve(error);
                });
        });

    }


    validateData = () => {
        var errors = this.state.errors;
        var error = false;

        if (this.state.typeOfDocument === "") {
            errors.typeOfDocument = "Seleccione un tipo de documento";
            error = true;
        } else {
            errors.typeOfDocument = "";
        }

        if (this.state.documentNumber === "") {
            errors.documentNumber = "Ingrese un número de documento";
            error = true;
        } else {
            errors.documentNumber = "";
        }

        if (this.state.names === "") {
            errors.names = "Ingrese al menos un nombre";
            error = true;
        } else {
            errors.names = "";
        }

        if (this.state.firstLastName === "") {
            errors.firstLastName = "Ingrese apellido";
            error = true;
        } else {
            errors.firstLastName = "";
        }

        if (this.state.secondLastName === "") {
            errors.secondLastName = "Ingrese apellido";
            error = true;
        } else {
            errors.secondLastName = "";
        }

        if (this.state.country === "") {
            errors.country = "Seleccione un país";
            error = true;
        } else {
            errors.country = "";
        }

        if (this.state.department === "") {
            errors.department = "Seleccione un departamento";
            error = true;
        } else {
            errors.department = "";
        }

        if (this.state.city === "") {
            errors.city = "Seleccione una ciudad";
            error = true;
        } else {
            errors.department = "";
        }

        if (this.state.address === "") {
            errors.address = "Ingrese una dirección";
            error = true;
        } else {
            errors.address = "";
        }

        if (this.state.telephone1 === "") {
            errors.telephone1 = "Ingrese una telefono";
            error = true;
        } else {
            errors.telephone1 = "";
        }

        if (this.state.cellphone === "") {
            errors.cellphone = "Ingrese un celular";
            error = true;
        } else {
            errors.cellphone = "";
        }

        if (this.state.email === "") {
            errors.email = "Ingrese un email";
            error = true;
        } else {
            errors.email = "";
        }

        if (this.state.tipoCont === "") {
            errors.tipoCont = "Ingrese un tipo de contrato";
            error = true;
        } else {
            errors.tipoCont = "";
        }

        if (this.state.specialtiesSpecSelected.length <= 0) {
            errors.esp = "Ingrese almenos una especialidad para este profesional";
            error = true;
        } else {
            errors.esp = "";
        }

        console.log(errors);
        this.setState({ errors: errors, error: error });
        return error;
    }

    fetchDataRegisterSpecialistProfesionals = () => {
        return new Promise((resolve, reject) => {

            let id_profesional = this.props.location.state.professional.contenido[0].id_profesional;
            console.log(id_profesional);
            fetch(process.env.REACT_APP_PUBLIC_URL + 'profesional-especialidad/listar-por-profesional?id_profesional='+id_profesional, {
                method: 'GET',
                headers: {
                    authorization: 'Bearer ' + sessionStorage.getItem('token'),
                }
            }).then(response => {
                return response.json();
            }).then(spec_prof => {
                let specSel = [];
                for(let i = 0; i < spec_prof.length; i++)
                {
                    let dataSpec = this.state.specialtiesSpec.find(specResponse => specResponse.id_especialidad === spec_prof[i].id_especialidad);
                    specSel.push(dataSpec);
                }
                this.setState({ specialtiesSpecSelected: specSel });
                resolve(spec_prof);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    fetchDataSpecialist = () => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'especialidad/listar', {
                method: 'GET',
                headers: {
                    authorization: 'Bearer ' + sessionStorage.getItem('token'),
                }
            }).then(response => {
                console.log(response);
                return response.json();
            }).then(specialists => {
                console.log("Sucess:" + specialists);
                this.setState({ specialtiesSpec: specialists });
                resolve(specialists);
            }).catch((error) => {
                reject(error)
            });
        });
    };

    updateProfesional = async () => {

        let form_error = this.validateData();
        if(form_error) {
            return;
        }
        
        var data = {
            ape1: this.state.firstLastName,
            ape2: this.state.secondLastName,
            nombres: this.state.names,
            regMed: this.state.regMed,
            rethus: this.state.rethus,
            licOC: this.state.licOC,
            dire: {
                id_pais: '38',
                id_dpto: this.state.department,
                id_ciudad: this.state.city,
                direccion: this.state.address
            },
            telf: this.state.telephone1,
            cel1: this.state.cellphone,
            cel2: this.state.telephone2,
            correo: this.state.email,
            tipoProf: this.state.tipoProf,
            tipoCont: this.state.tipoCont,
            esp: this.state.specialtiesSpecSelected,
            id_profesional: this.state.id_professional,
            id_perfil: 10,
            tipDoc: this.state.typeOfDocument,
            numDoc: this.state.documentNumber
        };

        console.log(data);

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'profesional/update', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                if (response.status === 200) {
                    return response.text();
                }
                else {
                    throw new Error(`Ha ocurrido un error en el servidor`);
                }
            })
            .then(data => {
                console.log(data);
                this.setState({
                    openAlert: true,
                    modalAlert: {
                        message: "Profesional Actualizado con Exito",
                        color: 'success',
                        title: "Exitoso!"
                    }
                });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    render() {
        const { classes } = this.props;
        return (
            <Container>
                <Col>
                    <Col md={12}>
                        <h3 style={{ marginBottom: 30 }}>Actualizar Profesional</h3>
                        <Button
                            style={{ marginBottom: 20 }}
                            color="primary"
                            size="sm"
                            onClick={() => {
                                history.push({
                                    pathname: process.env.PUBLIC_URL + '/config/professional-list'
                                });
                            }}
                        >
                            <ArrowBackIcon />
                        </Button>
                    </Col>
                    <Card >
                        <CardBody>
                            <div style={{ marginLeft: 10, marginTop: 10 }}>
                                <h5>Datos básicos</h5>
                            </div>
                            <div style={{ flex: 1, flexDirection: 'row' }}>
                                <FormControl
                                    className={classes.date}
                                    error={this.state.errors.hasOwnProperty("typeOfDocument") ? this.state.errors.typeOfDocument !== "" : false}
                                >
                                    <InputLabel required id="demo-simple-select-label" >Tipo  de Documento</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="id-simple-select"
                                        defaultValue={null}
                                        value={this.state.typeOfDocument}
                                        onChange={(event) => {
                                            console.log(event);
                                            this.handlerTypeOfDocument(event.target.value);
                                        }}
                                        error={this.state.errors.hasOwnProperty("typeOfDocument") ? this.state.errors.typeOfDocument !== "" : false}
                                    >
                                        <MenuItem className="material-form__option" key={0} value={''}>Ninguno</MenuItem>
                                        <MenuItem className="material-form__option" key={1} value={'CC'}>CC-Cedula de Ciudadania</MenuItem>
                                        <MenuItem className="material-form__option" key={2} value={'PA'}>PA-Pasaporte</MenuItem>
                                        <MenuItem className="material-form__option" key={3} value={'CE'}>CE-Cedula de Extranjeria</MenuItem>
                                        <MenuItem className="material-form__option" key={4} value={'SC'}>SC-Salvo Conducto</MenuItem>
                                        <MenuItem className="material-form__option" key={5} value={'CD'}>CD-Carnet Diplomatico</MenuItem>
                                    </Select>
                                    <FormHelperText>{this.state.errors.typeOfDocument}</FormHelperText>
                                </FormControl>
                                <TextField
                                    required
                                    className={classes.date}
                                    id="document-number-standard-required"
                                    label="N° de documento"
                                    type="number"
                                    value={this.state.documentNumber}
                                    onChange={(e) => {
                                        this.handlerDocumentNumber(e.target.value);
                                    }}
                                    error={this.state.errors.hasOwnProperty("documentNumber") ? this.state.errors.documentNumber !== "" : false}
                                    helperText={this.state.errors.documentNumber}
                                />

                            </div>
                            <div style={{ flex: 1, flexDirection: 'row' }}>
                                <div style={{ flex: 1, flexDirection: 'row' }}>
                                    <TextField
                                        required
                                        className={classes.date}
                                        id="first-name-standard-required"
                                        label="Nombres"
                                        type="text"
                                        value={this.state.names}
                                        onChange={(e) => {
                                            this.handlerNames(e.target.value);
                                        }}
                                        error={this.state.errors.hasOwnProperty("names") ? this.state.errors.names !== "" : false}
                                        helperText={this.state.errors.names}
                                    />
                                    <TextField
                                        required
                                        className={classes.date}
                                        id="first-last-name-standard-required"
                                        label="Primer apellido"
                                        type="text"
                                        value={this.state.firstLastName}
                                        onChange={(e) => {
                                            this.handlerFirstLastName(e.target.value);
                                        }}
                                        error={this.state.errors.hasOwnProperty("firstLastName") ? this.state.errors.firstLastName !== "" : false}
                                        helperText={this.state.errors.firstLastName}
                                    />
                                    <TextField
                                        required
                                        className={classes.date}
                                        id="second-last-name-standard-required"
                                        label="Segundo apellido"
                                        type="text"
                                        value={this.state.secondLastName}
                                        onChange={(e) => {
                                            this.handlerSecondLastName(e.target.value);
                                        }}
                                        error={this.state.errors.hasOwnProperty("secondLastName") ? this.state.errors.secondLastName !== "" : false}
                                        helperText={this.state.errors.secondLastName}
                                    />

                                    <TextField
                                        required
                                        className={classes.date}
                                        id="first-telephone-standard-required"
                                        label="Teléfono 1"
                                        type="text"
                                        value={this.state.telephone1}
                                        onChange={(e) => {
                                            this.handlerTelephone1(e.target.value);
                                        }}
                                        error={this.state.errors.hasOwnProperty("telephone1") ? this.state.errors.telephone1 !== "" : false}
                                        helperText={this.state.errors.telephone1}
                                    />
                                    <TextField
                                        className={classes.date}
                                        id="second-telephone-standard-required"
                                        label="Teléfono 2"
                                        type="text"
                                        value={this.state.telephone2}
                                        onChange={(e) => {
                                            this.handlerTelephone2(e.target.value);
                                        }}
                                    />
                                    <TextField
                                        required
                                        className={classes.date}
                                        id="cellphone-standard-required"
                                        label="Celular"
                                        type="text"
                                        value={this.state.cellphone}
                                        onChange={(e) => {
                                            this.handlerCellphone(e.target.value);
                                        }}
                                        error={this.state.errors.hasOwnProperty("cellphone") ? this.state.errors.cellphone !== "" : false}
                                        helperText={this.state.errors.cellphone}
                                    />
                                    <TextField
                                        required
                                        className={classes.date}
                                        id="email-standard-required"
                                        label="Correo electrónico"
                                        type="email"
                                        value={this.state.email}
                                        onChange={(e) => {
                                            this.handlerEmail(e.target.value);
                                        }}
                                        error={this.state.errors.hasOwnProperty("email") ? this.state.errors.email !== "" : false}
                                        helperText={this.state.errors.email}
                                    />
                                    <div style={{ marginLeft: 10, marginTop: 10 }}>
                                        <h5>Datos Professional</h5>
                                    </div>
                                    <div>
                                        <TextField
                                            required
                                            className={classes.date}
                                            id="regMed-standard-required"
                                            label="Registro Medico"
                                            type="text"
                                            value={this.state.regMed}
                                            onChange={(e) => {
                                                this.handlerRegMed(e.target.value);
                                            }}
                                            error={this.state.errors.hasOwnProperty("regMed") ? this.state.errors.regMed !== "" : false}
                                            helperText={this.state.errors.regMed}
                                        />
                                        <TextField
                                            required
                                            className={classes.date}
                                            id="rethus-standard-required"
                                            label="rethus"
                                            type="text"
                                            value={this.state.rethus}
                                            onChange={(e) => {
                                                this.handlerRethus(e.target.value);
                                            }}
                                            error={this.state.errors.hasOwnProperty("rethus") ? this.state.errors.rethus !== "" : false}
                                            helperText={this.state.errors.rethus}
                                        />
                                        <TextField
                                            required
                                            className={classes.date}
                                            id="licOC-standard-required"
                                            label="licencia OC"
                                            type="text"
                                            value={this.state.licOC}
                                            onChange={(e) => {
                                                this.handlerLicOC(e.target.value);
                                            }}
                                            error={this.state.errors.hasOwnProperty("licOC") ? this.state.errors.licOC !== "" : false}
                                            helperText={this.state.errors.licOC}
                                        />
                                        <TextField
                                            required
                                            className={classes.date}
                                            id="licOC-standard-required"
                                            label="Tipo de Profesional"
                                            type="text"
                                            value={this.state.tipoProf}
                                            onChange={(e) => {
                                                this.handlerTiprof(e.target.value);
                                            }}
                                            error={this.state.errors.hasOwnProperty("tipoProf") ? this.state.errors.tipoProf !== "" : false}
                                            helperText={this.state.errors.tipoProf}
                                        />
                                        <FormControl
                                            className={classes.date}
                                            error={this.state.errors.hasOwnProperty("tipoCont") ? this.state.errors.country !== "" : false}
                                        >
                                            <InputLabel id="contract-type-select-label">Tipo de Contrato</InputLabel>
                                            <Select
                                                labelId="contract-type-select-label"
                                                id="id-simple-select"
                                                defaultValue={null}
                                                value={this.state.tipoCont}
                                                onChange={(event) => {
                                                    //this.handlerBloodType(event.target.value);
                                                    this.handlerTipoCont(event.target.value);
                                                }}
                                            //error={this.state.errors.hasOwnProperty("contractType") ? this.state.errors.tipoCont !== "" : false}
                                            >
                                                <MenuItem key={0} value={'Fijo'}>Fijo</MenuItem>
                                                <MenuItem key={1} value={'Indefinido'}>Indefinido</MenuItem>
                                                <MenuItem key={2} value={'Prestacion de Servicios'}>Prestacion de Servicios</MenuItem>

                                            </Select>
                                            <FormHelperText>{this.state.errors.tipoCont}</FormHelperText>
                                        </FormControl>

                                        {
                                            <FormControl
                                                className={classes.date}
                                                required
                                                style={{ width: 200 }}
                                                error={this.state.errors.hasOwnProperty("esp") ? this.state.errors.esp !== "" : false}
                                                id="licOC-standard-required"
                                            >
                                                <InputLabel style={{ color: '#646777' }} id="demo-simple-select-label" shrink={true}>
                                                    Especialidades
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-multiple-checkbox-label"
                                                    id="demo-multiple-checkbox"
                                                    multiple
                                                    value={this.state.specialtiesSpecSelected}
                                                    onChange={(event) => {
                                                        this.handlerSpecialties(event.target.value);
                                                    }}
                                                    input={<Input />}
                                                    renderValue={(selecteds) => {
                                                        return selecteds.map((spec, index) => (
                                                            <span>
                                                                {spec.especialidad}{index >= selecteds.length - 1 ? null : ","}
                                                            </span>
                                                        ));
                                                    }}
                                                    MenuProps={MenuProps}
                                                    error={this.state.errors.hasOwnProperty("esp") ? this.state.errors.esp !== "" : false}
                                                >
                                                    {this.state.specialtiesSpec.map((spec) => (
                                                        <MenuItem
                                                            key={spec.id_especialidad} value={spec}>
                                                            <MedicalCheckbox 
                                                             checked={this.state.specialtiesSpecSelected.indexOf(spec) > -1} />
                                                            <ListItemText primary={spec.especialidad} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText>{this.state.errors.esp}</FormHelperText>
                                            </FormControl>}
                                    </div>

                                    <div style={{ marginLeft: 10, marginTop: 10 }}>
                                        <h5>Datos Ubicación</h5>
                                    </div>
                                    <div>
                                        <FormControl
                                            className={classes.date}
                                            error={this.state.errors.hasOwnProperty("country") ? this.state.errors.country !== "" : false}
                                        >
                                            <InputLabel id="country-status-select-label">País</InputLabel>
                                            <Select
                                                labelId="country-select-label"
                                                id="id-simple-select"
                                                defaultValue={null}
                                                value={this.state.country}
                                                onChange={(event) => {
                                                    this.handlerCountry(event.target.value);
                                                }}
                                                error={this.state.errors.hasOwnProperty("country") ? this.state.errors.country !== "" : false}
                                            >
                                                <MenuItem key={1} value={38}>Colombia</MenuItem>
                                            </Select>
                                            <FormHelperText>{this.state.errors.country}</FormHelperText>
                                        </FormControl>
                                        <FormControl
                                            className={classes.date}
                                            error={this.state.errors.hasOwnProperty("department") ? this.state.errors.department !== "" : false}
                                        >
                                            <InputLabel id="department-status-select-label">Departamento</InputLabel>
                                            <Select
                                                labelId="department-select-label"
                                                id="id-department-simple-select"
                                                defaultValue={null}
                                                value={this.state.department}
                                                onChange={(event) => {
                                                    this.handlerDepartment(event.target.value);
                                                }}
                                                error={this.state.errors.hasOwnProperty("department") ? this.state.errors.department !== "" : false}
                                            >
                                                {this.state.departments.map((department) => {
                                                    return <MenuItem key={department.id} value={department.depcod}>{department.depnom}</MenuItem>
                                                })}
                                            </Select>
                                            <FormHelperText>{this.state.errors.department}</FormHelperText>
                                        </FormControl>
                                        <FormControl
                                            className={classes.date}
                                            error={this.state.errors.hasOwnProperty("city") ? this.state.errors.city !== "" : false}
                                        >
                                            <InputLabel id="city-status-select-label">Ciudad</InputLabel>
                                            <Select
                                                labelId="city-select-label"
                                                id="id-city-simple-select"
                                                defaultValue={null}
                                                value={this.state.city}
                                                onChange={(event) => {
                                                    this.handlerCity(event.target.value);
                                                }}
                                                error={this.state.errors.hasOwnProperty("city") ? this.state.errors.city !== "" : false}
                                            >
                                                {this.state.cities.map((city) => {
                                                    return <MenuItem key={city.id} value={city.ciucod}>{city.ciunom}</MenuItem>
                                                })}
                                            </Select>
                                            <FormHelperText>{this.state.errors.city}</FormHelperText>
                                        </FormControl>
                                        <TextField
                                            required
                                            className={classes.date}
                                            id="address-standard-required"
                                            label="Dirección"
                                            type="text"
                                            value={this.state.address}
                                            onChange={(e) => {
                                                this.handlerAddress(e.target.value);
                                            }}
                                            error={this.state.errors.hasOwnProperty("address") ? this.state.errors.address !== "" : false}
                                            helperText={this.state.errors.address}
                                        />
                                    </div>
                                </div>
                                <Button
                                    className={classes.date}
                                    style={{ marginTop: 20 }}
                                    color="primary"
                                    onClick={this.updateProfesional}
                                >
                                    Actualizar Profesional
                                </Button>
                            </div>
                            {this.state.openAlert ?
                                <ModalMessage
                                    color={this.state.modalAlert.color}
                                    title={this.state.modalAlert.title}
                                    message={this.state.modalAlert.message}
                                    modal={this.state.openAlert}
                                    toggle={() => { this.setState({ openAlert: !this.state.openAlert }) }}
                                    onOk={() => {
                                        history.push({
                                            pathname: process.env.PUBLIC_URL + '/config/professional-list'
                                        });
                                    }}
                                /> : null}
                            <Modal
                                open={this.state.openMap}
                                onClose={e => {
                                    this.setState({ openMap: !this.state.openMap });
                                }}
                                aria-labelledby="simple-modal-title"
                                aria-describedby="simple-modal-description"
                            //style={{zIndex: 1000 }}
                            >
                                <div style={{
                                    position: 'absolute',
                                    backgroundColor: 'white',
                                    width: '80%',
                                    height: '80%',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    padding: 20
                                }}
                                >
                                    <MapAddressSearch />
                                </div>
                            </Modal>
                        </CardBody>
                    </Card>
                </Col>
            </Container>
        )
    }
}

export default withStyles(styles, { withTheme: true })(FormProfessional);